import { StyleSheet, View, Text } from "react-native";
import SafeAreaView from "../components/SafeAreaView";
import PageHeader from "../components/PageHeader";
import { ScrollView } from "react-native-gesture-handler";
import { Linking } from "react-native";
import { getSchemeStyle } from "../context/helper";

const MakeCall = (phoneNumber) => {
  Linking.openURL(`tel:${phoneNumber}`);
};
const MailTo = (eMail) => {
  Linking.openURL(`mailto:${eMail}`);
};
const OpenURL = (url) => {
  Linking.openURL(url);
};
const ImpressumScreen = ({ navigation }) => {
  const schemeStyles = getSchemeStyle();

  return (
    <SafeAreaView style={[styles.mainContainer,schemeStyles.Background]}>
      <PageHeader navigation={navigation} showBack={true} />
      <ScrollView style={styles.impContainer}>
        <View style={styles.headerContainer}>
          <Text style={[styles.impHeader,schemeStyles.defaultText]}>Impressum</Text>
        </View>
        <View style={styles.subHeaderContainer}>
          <Text style={[styles.impSubHeader,schemeStyles.defaultText]}>Gesetzliche Anbieterkennung:</Text>
        </View>

        <View style={styles.sectionContainer}>
          <View>
            <Text style={schemeStyles.defaultText}>Catering Equipment Gastronomie Service GmbH</Text>
            <Text style={schemeStyles.defaultText}>diese vertr. d. d. Geschäftsführer Tino Anders</Text>
          </View>
          <View>
            <Text style={schemeStyles.defaultText}>Märkersteig 12-16</Text>
          </View>
          <View>
            <Text style={schemeStyles.defaultText}>14974 Ludwigsfelde</Text>
          </View>
          <View>
            <Text style={schemeStyles.defaultText}>Deutschland</Text>
          </View>
        </View>
        <View style={styles.sectionContainer}>
          <View style={styles.tableContainer}>
            <Text style={[styles.tableFirstCol,schemeStyles.defaultText]}>Telefon:</Text>
            <Text
              style={schemeStyles.linkText}
              onPress={() => {
                MakeCall("03378-2051945");
              }}
            >
              03378-2051945
            </Text>
          </View>
          <View style={styles.tableContainer}>
            <Text style={[styles.tableFirstCol,schemeStyles.defaultText]}>Telefax:</Text>
            <Text style={schemeStyles.defaultText}>03378-2051949</Text>
          </View>
          <View style={styles.tableContainer}>
            <Text style={[styles.tableFirstCol,schemeStyles.defaultText]}>E-Mail:</Text>
            <Text
              style={schemeStyles.linkText}
              onPress={() => {
                MailTo("post@sencono.de");
              }}
            >
              post@sencono.de
            </Text>
          </View>
        </View>
        <View style={styles.sectionContainer}>
          <View style={styles.tableContainer}>
            <Text style={[styles.tableFirstCol,schemeStyles.defaultText]}>USt-IdNr.:</Text>
            <Text style={schemeStyles.defaultText}>DE156347349</Text>
          </View>
          <View style={styles.tableContainer}>
            <Text style={[styles.tableFirstCol,schemeStyles.defaultText]}>Wi-ID-Nr.:</Text>
            <Text style={schemeStyles.defaultText}>DUNS331613414</Text>
          </View>
        </View>
        <View style={styles.sectionContainer}>
          <View>
            <Text style={schemeStyles.defaultText}>
              <Text style={styles.boldText}>Sencono </Text>
              <Text>
                ist eine eingetragene Marke der Catering Equipment Gastronomie
                Service GmbH
              </Text>
            </Text>
          </View>
        </View>
        <View style={styles.sectionContainer}>
          <View>
            <Text style={schemeStyles.defaultText}>
              eingetragen im Handelsregister des Amtsgerichtes Potsdam
            </Text>
          </View>
          <View>
            <Text style={schemeStyles.defaultText}>Handelsregisternummer HRB HRB 6102</Text>
          </View>
        </View>
        <View style={styles.sectionContainer}>
          <View>
            <Text style={schemeStyles.defaultText}>Alternative Streitbeilegung:</Text>
          </View>
          <View>
            <Text style={schemeStyles.defaultText}>
              Die Europäische Kommission stellt eine Plattform für die
              außergerichtliche Online-Streitbeilegung (OS-Plattform) bereit,
              aufrufbar unter <Text style={[styles.url,schemeStyles.linkText]} onPress={() => {OpenURL('https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=DE');}}>https://ec.europa.eu/odr</Text>.
            </Text>
          </View>
        </View>
        <View>
          <Text style={schemeStyles.defaultText}>
            Unser Unternehmen ist weder verpflichtet noch bereit an der
            alternativen Streitbeilegung teilzunehmen.
          </Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default ImpressumScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingVertical: 20,
  },
  impContainer: {
    marginHorizontal: 10,
  },
  headerContainer: {
    marginBottom: 10,
  },
  impHeader: {
    fontSize: 18,
    fontFamily: "Roboto-Medium",
  },
  subHeaderContainer: {
    marginBottom: 5,
  },
  impSubHeader: {
    fontFamily: "Roboto-Bold",
  },
  sectionContainer: {
    marginBottom: 10,
  },
  tableContainer: {
    flexDirection: "row",
  },
  tableFirstCol: {
    width: 70,
  },
  boldText: {
    fontFamily: "Roboto-Bold",
  },
  markeContainer: {
    flexDirection: "row",
  },
  url: {
    textDecorationLine: "underline"
  },
});
